// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2WeVN","inner":"Footer_inner__C-2Ss","nextIcon":"Footer_nextIcon__1oJsz","innerLeft":"Footer_innerLeft__GiSTy"};